export default __webpack_public_path__ + "static/media/checkbox.9e1be6d8.svg";